import { render } from "./InstallationPage.vue?vue&type=template&id=13c17ac7&scoped=true"
import script from "./InstallationPage.vue?vue&type=script&lang=js"
export * from "./InstallationPage.vue?vue&type=script&lang=js"

import "./InstallationPage.vue?vue&type=style&index=0&id=13c17ac7&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c17ac7"]])

export default __exports__